export default __webpack_public_path__ + "static/Fig 4 - Site Proposals-6e58998de014d05858d3d4af4cca7cbc.pdf";